
/**
 * 比赛项目配置
 */

const EVENTS_CONFIG = [
  {
    name: '男子传统健美',
    value: 0
  },
  {
    name: '健美元老组',
    value: 1
  },
  {
    name: '男子古典健美',
    value: 2
  },
  {
    name: '男子古典健体',
    value: 100
  },
  {
    name: '男子健体',
    value: 3
  },
  {
    name: '女子比基尼',
    value: 4
  },
  {
    name: '男子健身模特',
    value: 5
  },
  {
    name: '女子健身模特',
    value: 6
  },
  {
    name: '男子体育模特',
    value: 7
  },
  {
    name: '女子体育模特',
    value: 8
  },
  {
    name: '女子Fit Model',
    value: 101
  },
  {
    name: '男子Fit Model',
    value: 102
  },
  {
    name: '女子形体',
    value: 9
  },
  {
    name: '女子健美',
    value: 10
  },
  {
    name: '女子健体',
    value: 11
  },
  {
    name: '女子美臀',
    value: 12
  },
  {
    name: '女子健康小姐',
    value: 13
  },
  {
    name: '男子健身',
    value: 14
  },
  {
    name: '女子健身',
    value: 15
  },
  {
    name: 'Cosplay',
    value: 16
  },
  {
    name: '型格健体',
    value: 17
  },
  {
    name: '男女混双',
    value: 18
  },
  {
    name: '女神模特',
    value: 19
  },
  {
    name: '肌肉模特',
    value: 20
  }
]

const GROUPS_CONFIG = [
  {
    name: '公开组',
    value: 'public'
  },
  {
    name: '青年组',
    value: 'youth'
  },
  {
    name: '新秀组',
    value: 'new'
  },
  {
    name: '首秀组',
    value: 'first'
  },
  {
    name: '新人组',
    value: 'newbee'
  },
  {
    name: '大学生组',
    value: 'student'
  },
  {
    name: '高校组',
    value: 'college'
  },
  {
    name: '在校组',
    value: 'student-in-school'
  },
  {
    name: '院校组',
    value: 'student-in-school-2'
  },
  {
    name: '毕业组',
    value: 'student-graduation'
  },
  {
    name: '元老组',
    value: 'elder'
  },
  {
    name: '本地组',
    value: 'local'
  },
  {
    name: '少年组',
    value: 'juvenile'
  },
  {
    name: '大师组',
    value: 'master'
  },
  {
    name: '逆龄组',
    value: 'niling'
  },
  {
    name: '职业组',
    value: 'pro'
  },
  {
    name: '辣妈组',
    value: 'lama'
  },
  {
    name: '残障组',
    value: 'canzhang'
  },
  {
    name: '模特组',
    value: 'model'
  },
  {
    name: '中学组',
    value: 'middleSchool'
  },
  {
    name: '自然组',
    value: 'ziran'
  },
  {
    name: '业余组',
    value: 'yeyu'
  },
  {
    name: '追梦组',
    value: 'free'
  }
]

const RANK_CONFIG = [
  // -1-未定义，0-校赛，1-区赛，2-市赛，3-省赛，4-区域赛，5-全国赛，6-亚洲级，7-世界级，8-商业赛，9-职业卡资格赛，10-职业赛，11-奥赛
  {
    level: '未定义',
    value: -1
  },
  {
    level: '校赛',
    value: 0
  },
  {
    level: '区赛',
    value: 1
  },
  {
    level: '市赛',
    value: 2
  },
  {
    level: '省赛',
    value: 3
  },
  {
    level: '区域赛',
    value: 4
  },
  {
    level: '全国赛',
    value: 5
  },
  {
    level: '亚洲级',
    value: 6
  },
  {
    level: '世界级',
    value: 7
  },
  {
    level: '商业赛',
    value: 8
  },
  {
    level: '职业卡资格赛',
    value: 9
  },
  {
    level: '职业赛',
    value: 10
  },
  {
    level: '奥赛',
    value: 11
  }
]

const REGISTER_TYPE = [
  // 报名方式类型 0-报名链接，1-二维码报名，2-邮箱报名, 3-微信报名，4-电话报名，5-线下报名，6-其他方式报名
  {
    label: '报名链接',
    value: 0
  },
  {
    label: '报名二维码',
    value: 1
  },
  {
    label: '邮箱报名',
    value: 2
  },
  {
    label: '微信报名',
    value: 3
  },
  {
    label: '电话报名',
    value: 4
  },
  {
    label: '线下报名',
    value: 5
  },
  {
    label: '其他方式报名',
    value: 6
  }
]

const CONTACT_TYPE = [
  // 类型：0-微信,1-电话,2-微信同电话,3-邮箱
  {
    label: '微信',
    value: 0
  },
  {
    label: '电话',
    value: 1
  },
  {
    label: '微信同电话',
    value: 2
  },
  {
    label: '邮箱',
    value: 3
  }
]

const REGISTER_FORM_TYPE = [
  // 类型：0-微信,1-电话,2-微信二维码,3-微信群二维码
  {
    label: '微信',
    value: 0
  },
  {
    label: '电话',
    value: 1
  },
  {
    label: '微信二维码',
    value: 2
  },
  {
    label: '微信群二维码',
    value: 3
  }
]


const REGION_TYPE_ONE = [
  {
    label: '未定义',
    value: -1
  },
  {
    label: '京津冀',
    value: 0
  },
  {
    label: '东三省',
    value: 1
  },
  {
    label: '陕甘宁',
    value: 2
  },
  {
    label: '粤港澳',
    value: 3
  },
  {
    label: '江浙沪',
    value: 4
  },
  {
    label: '川渝',
    value: 7
  },
  {
    label: '云贵',
    value: 8
  },
  {
    label: '青藏地区',
    value: 9
  },
  {
    label: '台湾省',
    value: 10
  }
]

const REGION_TYPE_TWO = [
  {
    label: '未定义',
    value: -1
  },
  {
    label: '西北地区',
    value: 0
  },
  {
    label: '华北地区',
    value: 1
  },
  {
    label: '华中地区',
    value: 2
  },
  {
    label: '华南地区',
    value: 3
  },
  {
    label: '华东地区',
    value: 4
  },
  {
    label: '西南地区',
    value: 5
  },
  {
    label: '东北地区',
    value: 6
  },
  {
    label: '东南地区',
    value: 7
  }
]

const ARTICLE_TYPE = [
  {
    label: '新闻',
    value: 0
  },
  {
    label: '成绩公告',
    value: 1
  },
  {
    label: '百科',
    value: 2
  }
]

const ARTICLE_STATUS = [
  {
    label: '草稿',
    value: 0,
    style: "info"
  },
  {
    label: '正常',
    value: 1,
    style: "success"
  },
  {
    label: '删除',
    value: 2,
    style: "danger"
  }
]

const RULE_TYPE = [
  {
    label: '其他',
    value: 1
  },
  {
    label: 'IFBB职业联盟',
    value: 2
  },
  {
    label: 'IFBB精英联盟',
    value: 3
  }
]

const REGISTRATION_DASHBOARD_BRANDS = [
  {
    id: 'juli',
    brand: '聚力',
    keyword: '聚力',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/b2e3f600d9544cfeb2b6a5abc4fd0b4d~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'huanji',
    brand: '寰际',
    keyword: '寰际',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/20fd1e71eb954a4f8392708f43b29789~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'jiaodoushi',
    brand: '角斗士',
    keyword: '角斗士',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/c891dfb41c984e6f94968b311f5bccd4~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'dms',
    brand: 'DMS',
    keyword: 'DMS',
    logo: 'http://cdn.jirou.fit/099be36293d71226a43058f1444c8ce4.png~tplv-700tmnc25s-image.image'
  },
  {
    id: 'dwows',
    brand: 'DWOWS',
    keyword: 'DWOWS',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/87a2e701ac734fce9203b352a35efe3a~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'fanxingzhe',
    brand: '凡星者',
    keyword: '凡星者',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/e54d0e41de7c486e9a1a6721ac0481d3~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'dna',
    brand: 'DNA',
    keyword: 'DNA',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/8cd61aa595e3416ebe1b6403ec844df5~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'musclemania',
    brand: 'Musclemania',
    keyword: 'Musclemania',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/6794b2c66d56467f8d4fcd8c58e9d981~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'redline',
    brand: '红线',
    keyword: '红线',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/201d6cae60c2482d84c05792b8b68d57~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'carvenos',
    brand: '卡维诺斯',
    keyword: '卡维诺斯',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/73c7559f35584d159798a4544649f7ae~tplv-700tmnc25s-yasuo.image'
  },
  {
    id: 'golden',
    brand: '黄金健美超级联赛',
    keyword: '黄金',
    logo: 'https://cdn.jirou.fit/tos-cn-i-700tmnc25s/8fa90d9018e84c968f4d001b8f5e7404~tplv-700tmnc25s-yasuo.image'
  }
]

export {
  EVENTS_CONFIG,
  GROUPS_CONFIG,
  RANK_CONFIG,
  REGISTER_TYPE,
  CONTACT_TYPE,
  REGISTER_FORM_TYPE,
  REGION_TYPE_ONE,
  REGION_TYPE_TWO,
  ARTICLE_TYPE,
  ARTICLE_STATUS,
  RULE_TYPE,
  REGISTRATION_DASHBOARD_BRANDS
}
